import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, finalize, of, throwError } from 'rxjs';
import { FunctionsService } from 'src/app/data/functions.service';

export interface ModalCriarMarca {
  textoNomeMarca: string,
}

@Component({
  standalone: false,
  selector: 'modal-criar-marca',
  templateUrl: 'modal-criar-marca-component.html',
})
export class ModalCriarMarca {
  public criarMarcaForm: UntypedFormGroup;
  public loading: Boolean;

  constructor(
    public dialogRef: MatDialogRef<ModalCriarMarca>,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    @Inject(MAT_DIALOG_DATA) public data: ModalCriarMarca,
    private _snackBar: MatSnackBar,
  ) {
    this.criarMarcaForm = this.formBuilder.group({
      nome: [{ value: data.textoNomeMarca, disabled: false }, [
        Validators.required
      ]],
    });
  }

  salvarNovaMarca(): any {
    const payload: any = {
      nome: this.criarMarcaForm.get('nome').value,
    };

    this.loading = true;
    this.criarMarcaForm.disable();
    this.functions.adicionaMarca(payload)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.criarMarcaForm.enable();
        })
      )
      .subscribe({
        next: (res) => {
          const marcaCreatedData = res.body.data;
          this.dialogRef.close(marcaCreatedData);
        },
        error: (err) => {
          console.error({ criarNovaMarcaError: err });

          if (err.error && err.error.status === 303 && err.error.data) {
            const marcaSeeOther = err.error.data;
            this._snackBar.open(`Marca "${payload.nome}" já existe, portanto foi selecionada para o produto.`, 'Entendi', {
              duration: 5000
            });
            this.dialogRef.close(marcaSeeOther);
          } else {
            alert('Ops, não conseguimos adicionar a marca.\nMotivo: ' + err.error.message);
          }
        }
      });
  }
}
